import logo from './logo.svg';
import './App.css';
import HomePage from './Homepage'; 

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <HomePage />
      </header>
    </div>
  );
}

export default App;
